import React from "react";

/**
 * @component ViewListIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ViewListIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ViewListIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ViewListIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M19 17a1 1 0 010 2H5a1 1 0 010-2h14zm0-6a1 1 0 010 2H5a1 1 0 010-2h14zm0-6a1 1 0 010 2H5a1 1 0 110-2h14z"
        fillRule="evenodd"
      />
    </svg>
  )
);
ViewListIcon.displayName = "ViewListIcon";
export default ViewListIcon;
